@if (bulkInvoiceWorkItems$ | async; as bulkInvoiceWorkItems) {
  <div class="main">
    @if (bulkInvoicegetEXandINC_GST$ | async; as bulkInvoicegetEXandINC_GST) {
      <div class="main">
        @if (SingleMatterData$ | async; as SingleMatterData) {
          <div>
            @if (isLoadingResults) {
              <div class="example-loading-shade">
                <mat-spinner [style.zoom]="1"></mat-spinner>
              </div>
            }
            <div class="mb-8 flex flex-row">
              <div class="flex w-[90%] justify-start">
                <div
                  class="flex flex-wrap items-center justify-between gap-[8px]"
                  [ngClass]="COLOR"
                >
                  <h2 class="flex-item">
                    <a
                      class="flex-shrink-0 cursor-pointer text-[20px] underline"
                      (click)="openMatter(bulkInvoiceWorkItems)"
                    >
                      <span
                        class="info hyper-link matter-detail-text-link mt-0 mb-0 text-[20px] underline"
                        [ngClass]="HyperlinkColor"
                      >
                        {{
                          bulkInvoiceWorkItems?.invoiceBulkWorkItems
                            ? bulkInvoiceWorkItems?.invoiceBulkWorkItems?.SHORTNAME
                            : '---'
                        }}
                      </span>
                    </a>
                  </h2>
                  <h2 class="flex-item">
                    <p class="info infobox overFlow mt-0 mb-0 cursor-pointer text-[20px]">
                      {{
                        bulkInvoiceWorkItems?.invoiceBulkWorkItems
                          ? bulkInvoiceWorkItems?.invoiceBulkWorkItems.MATTER
                          : '---'
                      }}
                    </p>
                  </h2>
                  <h2 class="flex-item">
                    <a class="overFlow-contact flex-shrink-0 cursor-pointer text-[20px] underline">
                      <span
                        class="info contact-name matter-detail-text-link mt-0 mb-0 cursor-pointer text-[20px] underline"
                        (click)="
                          openContactName(
                            $safeNavigationMigration(
                              bulkInvoiceWorkItems?.invoiceBulkWorkItems?.CONTACTGUID
                            )
                          )
                        "
                        [ngClass]="HyperlinkColor"
                      >
                        {{
                          bulkInvoiceWorkItems?.invoiceBulkWorkItems
                            ? bulkInvoiceWorkItems?.invoiceBulkWorkItems?.CONTACTNAME
                            : '---'
                        }}
                      </span>
                    </a>
                  </h2>
                </div>
              </div>
              <div class="close-icon flex w-[10%] items-center justify-end">
                <mat-icon (click)="close('BulkInvoicingWorkItemPanel')">clear</mat-icon>
              </div>
            </div>
            <div class="mb-4 flex flex-row justify-between">
              <div class="flex w-[35%]">
                @if (currentuserdata?.PRODUCTTYPE == 'Solicitor') {
                  <div class="w-[37%]">
                    <div class="flex flex-col">
                      <div class="party-headdata">
                        <h3><b>Owner</b></h3>
                      </div>
                      <div class="party-data">
                        <h3>
                          {{
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems
                              ? bulkInvoiceWorkItems?.invoiceBulkWorkItems?.OWNERNAME
                              : ' '
                          }}
                        </h3>
                      </div>
                    </div>
                  </div>
                }
                @if (currentuserdata?.PRODUCTTYPE == 'Solicitor') {
                  <div class="w-[35%]" style="margin-left: 30px">
                    <div class="flex flex-col">
                      <div class="party-headdata">
                        <h3><b>Primary Fee Earner</b></h3>
                      </div>
                      <div class="party-data">
                        <h3>
                          {{
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems
                              ? bulkInvoiceWorkItems?.invoiceBulkWorkItems?.PRIMARYFEEEARNERNAME
                              : ' '
                          }}
                        </h3>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="flex w-[65%] flex-row justify-end">
                <div class="header-bar w-[12%]">
                  <div class="flex flex-col">
                    <div class="party-headdata">
                      <h3><b>Previously Billed</b></h3>
                    </div>
                    <div class="party-data">
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems?.INVOICEDVALUEINCGST
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="header-bar w-[12%]">
                  <div class="flex flex-col">
                    <div class="party-headdata">
                      <h3><b>Unbilled (Ex)</b></h3>
                    </div>
                    <div class="party-data">
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems?.UNBILLEDVALUEEXGST
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="header-bar w-[12%]">
                  <div class="flex flex-col">
                    <div class="party-headdata">
                      <h3><b>Unbilled (Inc)</b></h3>
                    </div>
                    <div class="party-data">
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems?.UNBILLEDVALUEINCGST
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="header-bar w-[12%]">
                  <div class="flex flex-col">
                    <div class="party-headdata">
                      <h3><b>Outstanding(Inc)</b></h3>
                    </div>
                    <div class="party-data">
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems?.OUTSTANDINGVALUEINCGST
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bulk-list flex flex-row justify-between gap-10">
              <form style="width: 23%">
                <mat-slide-toggle
                  [(ngModel)]="isTaggingEnabled"
                  (change)="ToggleForUpadte()"
                  matTooltip="Turn on mass updates to enter tagging mode which gives you the ability to Delete, Move or Write Off WIP in bulk."
                  matTooltipPosition="above"
                  style="margin-top: 25px"
                >
                  Mass Updates
                </mat-slide-toggle>
              </form>
              <div class="bulk-sub-list flex w-[50%] gap-[10px]">
                <!-- <div fxLayout="column">
                <div>
                  <h3><b>Outstanding(Inc)</b></h3>
                </div>
                <div >
                  <h3>{{bulkInvoiceWorkItems?.invoiceBulkWorkItems?.OUTSTANDINGVALUEINCGST | toFixedAmount :true}}</h3>
                </div>
              </div> -->
                <ng-container>
                  <!-- <section
                [ngClass]="(appPermissions[1]?.Edit==0 || isMatterData =='empty') ? 'disabled-click-cursor ribbon-section' : 'ribbon-section'">
                <button mat-button
                  (click)="toolbarServiceService.matterpopup('edit')"
                  [ngClass]="(appPermissions[1]?.Edit==0 || isMatterData =='empty') ? 'disabled-click large-button' : 'large-button'"
                  id="editMatter">
                  <section
                    class="large-button-container">
                    <mat-icon class="main-icon">
                      <img
                        src="assets/icons/web_app/icon_matter_edit_d.ico">
                      </mat-icon>
                      <div class="main-text">
                        <span>Edit<br> Matter</span>
                      </div>
                    </section>
                  </button>
                </section> -->
                  <!-- <ng-container *ngIf="!Checktaggingstatus"> -->
                  @if (!Checktaggingstatus) {
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="callingPreview(bulkInvoiceWorkItems, SingleMatterData)"
                      >
                        <section
                          class="large-button-container !flex !flex-col !items-center !justify-center"
                        >
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Preview invoice icon.svg" />
                          </mat-icon>
                          <div class="main-text !mt-1 !block !text-center !leading-[1.2]">
                            <span>
                              Preview
                              <br />
                              Invoice
                            </span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="
                          SaveInvoice('Create Bulk Invoice', bulkInvoiceWorkItems, SingleMatterData)
                        "
                      >
                        <section
                          class="large-button-container !flex !flex-col !items-center !justify-center"
                        >
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Invoice add.svg" />
                          </mat-icon>
                          <div class="main-text !mt-1 !block !text-center !leading-[1.2]">
                            <span>
                              Create
                              <br />
                              Invoice
                            </span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="
                          SaveInvoice(
                            'Create+Generate Bulk Invoice',
                            bulkInvoiceWorkItems,
                            SingleMatterData
                          )
                        "
                      >
                        <section
                          class="large-button-container !flex !flex-col !items-center !justify-center"
                        >
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Generate Invoice.svg" />
                          </mat-icon>
                          <div class="main-text !mt-1 !block !text-center !leading-[1.2]">
                            <span>
                              Create +
                              <br />
                              Gen. Invoice
                            </span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="
                          SaveInvoice(
                            'Create+Email Bulk Invoice',
                            bulkInvoiceWorkItems,
                            SingleMatterData
                          )
                        "
                      >
                        <section
                          class="large-button-container !flex !flex-col !items-center !justify-center"
                        >
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Email Invoice.svg" />
                          </mat-icon>
                          <div class="main-text !mt-1 !block !text-center !leading-[1.2]">
                            <span>
                              Create +
                              <br />
                              Email Invoice
                            </span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        [matMenuTriggerFor]="menu"
                      >
                        <section
                          class="large-button-container !flex !flex-col !items-center !justify-center"
                        >
                          <mat-icon class="main-icon" style="width: 30px; height: 40px">
                            <!-- <img src="assets/icons/web_app/icon_time_cost_new_d.ico"> -->
                            <img src="assets/icons/web_app/Timer add.svg" />
                          </mat-icon>
                          <div class="main-text !mt-1 !block !text-center !leading-[1.2]">
                            <span>New Entry</span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <div class="ellipsis-menu">
                      <mat-menu #menu="matMenu">
                        <ng-container>
                          <ng-container>
                            <button
                              (click)="toolbarServiceService.addNewTimeEntry('NewTimeEntryMatter')"
                              mat-menu-item
                            >
                              <mat-icon class="main-icon">
                                <!-- <img src="assets/icons/web_app/icon_time_cost_new_d.ico"> -->
                                <img src="assets/icons/web_app/Timer add.svg" />
                              </mat-icon>
                              New Time Entry
                            </button>
                            <button (click)="ActivityDialog('new', 'Activities')" mat-menu-item>
                              <mat-icon class="main-icon">
                                <img src="assets/icons/web_app/Invoice add.svg" />
                              </mat-icon>
                              New Fixed Fee
                            </button>
                            <button (click)="ActivityDialog('new', 'Sundries')" mat-menu-item>
                              <mat-icon class="main-icon">
                                <img src="assets/icons/web_app/Spend Money add.svg" />
                              </mat-icon>
                              New Sundry
                            </button>
                            <button
                              (click)="
                                toolbarServiceService.spendmoneypopup(
                                  'new',
                                  'FromWIP',
                                  '',
                                  'NEW MATTER EXPENCE'
                                )
                              "
                              mat-menu-item
                            >
                              <mat-icon class="main-icon">
                                <img src="assets/icons/web_app/Spend Money add.svg" />
                              </mat-icon>
                              New Matter Expense
                            </button>
                          </ng-container>
                        </ng-container>
                      </mat-menu>
                    </div>
                    <section class="ribbon-section time-entries-wrap">
                      <mat-nav-list>
                        <a
                          mat-list-item
                          class="gap-3"
                          [ngClass]="
                            (appPermissions && appPermissions?.[7]?.Access == 0) ||
                            isWIPData == 'empty'
                              ? 'disabled-click-cursor ribbon-section'
                              : 'ribbon-section'
                          "
                          (click)="ReCalcTimeEntriClick()"
                        >
                          <mat-icon>
                            <img
                              class="timer-icon"
                              src="assets/icons/web_app/Recalculate time entries icon.svg"
                            />
                          </mat-icon>
                          <span>Re Calc Time Entries</span>
                        </a>
                        <a
                          mat-list-item
                          class="gap-3"
                          [ngClass]="
                            (appPermissions && appPermissions?.[7]?.Access == 0) ||
                            isWIPData == 'empty'
                              ? 'disabled-click-cursor ribbon-section'
                              : 'ribbon-section'
                          "
                          (click)="searchAndReplaceWorkItemOnClick()"
                        >
                          <mat-icon>
                            <img
                              class="timer-icon highlight-add"
                              src="assets/icons/web_app/Find replace icon.svg"
                            />
                          </mat-icon>
                          <span>Find/Replace</span>
                        </a>
                      </mat-nav-list>
                    </section>
                  }
                  @if (Checktaggingstatus) {
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="deleteTimeEntry()"
                        [ngClass]="
                          appPermissions?.[2]?.Delete == 0 ||
                          isWIPData == 'empty' ||
                          isshowButtons == false ||
                          showdeleteentries == false
                            ? 'disabled-click-cursor ribbon-section'
                            : 'ribbon-section'
                        "
                      >
                        <section class="large-button-container">
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Timer delete.svg" />
                          </mat-icon>
                          <div class="main-text">
                            <span>Delete Entries</span>
                          </div>
                        </section>
                      </button>
                    </section>
                    <section>
                      <button
                        mat-button
                        class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                        (click)="moveWIP()"
                        [ngClass]="
                          appPermissions?.[7]?.Access == 0 ||
                          isWIPData == 'empty' ||
                          isshowButtons == false
                            ? 'disabled-click-cursor ribbon-section'
                            : 'ribbon-section'
                        "
                      >
                        <section class="large-button-container">
                          <mat-icon class="main-icon">
                            <img src="assets/icons/web_app/Move time entry icon.svg" />
                          </mat-icon>
                          <div class="main-text">
                            <span>Move Entries</span>
                          </div>
                        </section>
                      </button>
                    </section>
                    @if (DisEnTimeEntryToolbar == 'write_off') {
                      <section>
                        <button
                          [ngClass]="
                            appPermissions?.[2]?.Edit == 0 ||
                            isWIPData == 'empty' ||
                            isshowButtons == false
                              ? 'disabled-click-cursor ribbon-section'
                              : 'ribbon-section'
                          "
                          mat-button
                          class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                          (click)="WriteOffTimeEntry('WIP')"
                        >
                          <section class="large-button-container">
                            <mat-icon class="main-icon">
                              <img src="assets/icons/web_app/Write off wip icon.svg" />
                            </mat-icon>
                            <div class="main-text">
                              <span>Write Off Entries</span>
                            </div>
                          </section>
                        </button>
                      </section>
                    }
                    @if (DisEnTimeEntryToolbar == 'undo') {
                      <section>
                        <button
                          [ngClass]="
                            appPermissions?.[7]?.Create == 0 || isWIPData == 'empty'
                              ? 'disabled-click-cursor ribbon-section'
                              : 'ribbon-section'
                          "
                          mat-button
                          class="large-button !leading-normal !h-auto !min-h-[70px] p-0 !px-3 !py-2"
                          (click)="UndoWriteOffTimeEntry('WIP')"
                        >
                          <section class="large-button-container">
                            <mat-icon class="main-icon">
                              <img src="assets/icons/web_app/icon_time_cost_delete_d.ico" />
                            </mat-icon>
                            <div class="main-text">
                              <span>Undo - Write Off Entries</span>
                            </div>
                          </section>
                        </button>
                      </section>
                    }
                  }
                </ng-container>
              </div>
              <div class="flex w-[50%] flex-row justify-end">
                <div class="sub-head w-[16.6%]">
                  <div class="flex flex-col" style="margin-left: 25px">
                    <div class="party-headdata">
                      <h3><b>Total (Ex)</b></h3>
                    </div>
                    <div>
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoicegetEXandINC_GST?.invoiceBulkgetEXandINC_GST?.EXGSTTOTAL
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="sub-head w-[16.6%]">
                  <div class="flex flex-col" style="margin-left: 25px">
                    <div class="party-headdata">
                      <h3><b>GST</b></h3>
                    </div>
                    <div>
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoiceWorkItems?.invoiceBulkWorkItems?.UNBILLEDVALUEINCGST
                          ) -
                            $safeNavigationMigration(
                              bulkInvoiceWorkItems?.invoiceBulkWorkItems?.UNBILLEDVALUEEXGST
                            ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="sub-head w-[16.6%]">
                  <div class="flex flex-col">
                    <div class="party-headdata">
                      <h3><b>Total (Inc)</b></h3>
                    </div>
                    <div>
                      <h3>
                        {{
                          $safeNavigationMigration(
                            bulkInvoicegetEXandINC_GST?.invoiceBulkgetEXandINC_GST?.INCGSTTOTAL
                          ) | toFixedAmount: true
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </div>
            @if (
              appPermissions &&
              appPermissions?.[31]?.Create == 1 &&
              currentuserdata?.PRODUCTTYPE == 'Solicitor'
            ) {
              <div class="bulk-list mb-8 flex flex-row justify-between gap-10">
                <form
                  name="bulkInvoiceForm"
                  id="bulkInvoiceForm"
                  [formGroup]="bulkInvoiceForm"
                  class="flex flex-[1_0_auto] flex-col justify-start"
                  name="form"
                >
                  <div class="bulk-invoicing flex flex-[1_0_auto] flex-col justify-start">
                    <div class="flex flex-[1_0_auto] flex-row items-center justify-start py-4">
                      <mat-slide-toggle
                        class="w-[30%]"
                        [checked]="RequestProtectedTrustAmount"
                        (change)="RequestProtectedTrustAmountToggle()"
                      >
                        Request Protected Trust Amount:
                      </mat-slide-toggle>
                      @if (RequestProtectedTrustAmount) {
                        @if (apiData?.MULTITRUST === 0) {
                          <mat-form-field appearance="outline" class="w-[60%]">
                            <mat-label>Trust Account</mat-label>
                            <!-- [disabled]="isdisable" -->
                            <input
                              formControlName="TrustAccount"
                              placeholder="Trust Account"
                              matInput
                              readonly
                            />
                          </mat-form-field>
                        }
                        @if (apiData?.MULTITRUST === 1) {
                          <mat-form-field appearance="outline" class="w-[60%]">
                            <mat-label>Trust Account</mat-label>
                            <mat-select
                              formControlName="BANKACCOUNTGUID"
                              placeholder="Trust Account"
                              (selectionChange)="changeGuid($event)"
                            >
                              @for (account of apiData?.TRUSTACCOUNTLIST; track account) {
                                <mat-option [value]="account.BANKACCOUNTGUID">
                                  {{ account.BANKACCOUNTNAME }} - Balance:
                                  {{ account.BANKACCOUNTBALANCE | currency }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        }
                      }
                    </div>
                    @if (RequestProtectedTrustAmount) {
                      @if (
                        bulkInvoiceForm.get('BANKACCOUNTGUID')?.value ||
                        bulkInvoiceForm.get('TrustAccount')?.value
                      ) {
                        <div class="mt-4 flex flex-row items-start justify-start gap-[32px]">
                          <!-- <mat-form-field appearance="outline" fxFlex="40" class="pr-2">
                                          <mat-label>Protection Type</mat-label>
                                          <mat-select formControlName="PROTECTEDTRUSTTYPE" placeholder="Protection Type">
                                            <mat-option value="This amount plus unprotected funds">This amount plus unprotected funds</mat-option>
                                            <mat-option value="This amount only">This amount only</mat-option>
                                          </mat-select>
                                        </mat-form-field> -->
                          <!-- <mat-form-field appearance="outline" fxFlex="25" class="pr-2 value_width_bulk extra_pad_bulk">
                                        <mat-label>Ledger Balance</mat-label>
                                        <input class="sideText" currencyMask matInput
                                          formControlName="TRUSTBALANCE"
                                          placeholder="Matter Ledger Balance"
                                          [(ngModel)]="bulkInvoiceWorkItemsMatter.TRUSTBALANCE">
                                        </mat-form-field> -->
                          <!-- <mat-form-field appearance="outline" fxFlex="23" class="pr-2">
                                        <input type="text" style="text-align: right;" matInput formControlName="PROTECTEDTRUSTAMOUNT" appCurrencyFormat>
                                      </mat-form-field> -->
                          <div class="w-[40%]" style="min-width: 100px">
                            <div class="ledger-row">
                              <span class="label">Matter Ledger Balance</span>
                              <span class="value">
                                {{
                                  accountResponse?.ACCOUNTBALANCE ?? 0 | currency: 'USD' : 'symbol'
                                }}
                              </span>
                            </div>
                            <div class="ledger-row">
                              <span class="label">Unprotected funds</span>
                              <span class="value">
                                {{
                                  accountResponse?.UNPROTECTEDFUNDSAMOUNT ?? 0
                                    | currency: 'USD' : 'symbol'
                                }}
                              </span>
                            </div>
                            <div class="ledger-row">
                              <span class="label">"Any Matter Invoice" Protections</span>
                              <span class="value">
                                {{
                                  accountResponse?.ANYINVOICEPROTECTEDAMOUNT ?? 0
                                    | currency: 'USD' : 'symbol'
                                }}
                              </span>
                            </div>
                          </div>
                          <div class="flex w-[60%] flex-col gap-[10px]">
                            <div class="toggle-row flex flex-row items-center justify-between">
                              <mat-slide-toggle
                                formControlName="PROTECTASMUCHASPOSSIBLE"
                                (change)="ProtectAsMuchAsPossibleToggle()"
                              >
                                Protect as much as possible
                              </mat-slide-toggle>
                              <mat-form-field
                                appearance="outline"
                                style="margin-top: 9px"
                                class="white-text-field amount-field"
                              >
                                <input
                                  matInput
                                  formControlName="PROTECTEDTRUSTAMOUNT"
                                  type="text"
                                  style="text-align: right"
                                  appCurrencyFormat
                                />
                              </mat-form-field>
                            </div>
                            <div class="toggle-row flex flex-row items-center justify-start">
                              <mat-slide-toggle
                                formControlName="USEANYMATTERINVOICEPROTECTIONS"
                                (change)="
                                  UtiliseExistingProtections = !UtiliseExistingProtections;
                                  calculateProtectedTrustAmount()
                                "
                              >
                                Utilise existing "Any Matter Invoice" Protections
                              </mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      } @else {
                        @if (!isLoadingResults) {
                          <p class="message">Please select the trust account you want to use</p>
                        }
                      }
                    }
                  </div>
                </form>
                <!-- <form style="width: 25%">
                            </form> -->
                <!-- <div fxFlex="50" class="flex gap-10 py-12 ml-16 minw-46 bulk-sub-list">
                            <ng-container *ngIf="RequestProtectedTrustAmount">
                              <mat-form-field *ngIf="apiData?.MULTITRUST === 0" appearance="outline" fxFlex="60">
                                <mat-label>Trust Account</mat-label>
                                <input [disabled]="isdisable" formControlName="TrustAccount" placeholder="Trust Account" matInput readonly>
                              </mat-form-field>
                              <mat-form-field *ngIf="apiData?.MULTITRUST === 1" appearance="outline" fxFlex="60">
                                <mat-label>Trust Account</mat-label>
                                <mat-select formControlName="BANKACCOUNTGUID" placeholder="Trust Account" (selectionChange)="changeGuid($event)">
                                  <mat-option *ngFor="let account of apiData?.TRUSTACCOUNTLIST"
                                    [value]="account.BANKACCOUNTGUID">{{ account.BANKACCOUNTNAME }} - Balance: {{ account.BANKACCOUNTBALANCE  | currency }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container>
                          </div> -->
              </div>
            }
            @if (
              bulkInvoiceWorkItems?.invoiceBulkWorkItems &&
              bulkInvoiceWorkItems?.invoiceBulkWorkItems != null
            ) {
              <div>
                <app-details
                  class="invoice_add_dialoug_form"
                  [MattersData]="
                    $safeNavigationMigration(bulkInvoiceWorkItems?.invoiceBulkWorkItems)
                  "
                ></app-details>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
